import React, { useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import { Select, Spin } from "antd"
import { Link } from "react-router-dom"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import {
  searchItemInTree,
  searchTree,
  truncateText,
  validate,
} from "../../../../../utils/functions"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectDimensionsDrillDown,
  makeSelectTeams,
  makeSelectIsLoadingDimensions,
} from "./selectors"
import { getDimensionsWatcher } from "./actions"
import ResultByDimensionChart from "../../../ReChart/ResultByDimensionChart"
import "./index.less"
import {
  isLeader,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../../../utils/storage"
import { Option } from "antd/lib/mentions"
import { loadTexts } from "../../../../../utils/i18n"

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function WidgetResultByDimensionTeam(props) {
  const intlWidgetResultByDimensionTeam = loadTexts("reports_general_view")
    .reportAmbassador.leadershipMeasurement.widgetResultByDimensionTeam
  const [measureID] = useState(props.idMeasure)
  const prevMeasureID = usePreviousMeasureID(measureID)
  const [dimensionParent, setDimensionParent] = useState(0)
  const [dataAux, setDataAux] = useState([])

  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    }
  }, [props.idMeasure])

  useEffect(() => {
    setDataChart()
  }, [props.dimensionsDrillDown])

  useEffect(() => {
    setDataChart()
  }, [dimensionParent])

  const initGetData = async () => {
    const { idMeasure, getDimensions, measureGeneral, selectedSegment } = props
    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
      recipients: true,
      anonymity: true,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_segment: selectedSegment,
      },
    }
    if (measureGeneral.is_engagement) {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }
    getDimensions(params)
  }

  const setDataChart = () => {
    const { dimensionsDrillDown } = props
    const dataResult = []
    let result = []
    if (dimensionParent === 0) {
      result = [...dimensionsDrillDown]
    } else {
      result = searchTree([...dimensionsDrillDown], dimensionParent)
    }
    result &&
      result.map((row) => {
        if (row.engagement) {
          return
        }
        let newValue = row.value
        if (!row.anonymity_check.valid) {
          newValue = 100
        }
        dataResult.push({
          name: `${row.name}`,
          impact: row.impact,
          name_sort: truncateText(row.name, 15),
          id_dimension: row.id_dimension,
          id_dimension_parent: row.id_dimension_parent,
          id: row.id,
          id_parent: row.id_parent,
          value: newValue,
          value_visible: row.value_visible,
          childs: row.childs,
          color: row.color,
          recipients: row.recipients,
          employees: row.employees,
          prev_value: row.prev_value,
          benchmark_value: row.benchmark_value,
          anonymity_check: row.anonymity_check,
        })
      })
    setDataAux(dataResult)
  }

  const changeDivision = (value) => {
    const { measureGeneral, idMeasure, getDimensions, selectedSegment } = props
    getDimensions({
      id_division: value,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
      engagement: true,
      recipients: true,
      anonymity: true,
      params: {
        id_division: value,
        id_segment: selectedSegment,
      },
    })
  }

  let querySegment = ""
  if (props.measureGeneral.segments.length > 1 && props.selectedSegment === 0) {
    querySegment = `?home=true&id_segment=${props.selectedSegment}`
  }

  const renderTitle = () => {
    const {
      idMeasure,
      idDivisionSelected,
      selectedSegment,
      measureGeneral,
    } = props

    const teams = getUniqueListBy(props.teams, "id_position")

    let querySegment = ""
    let queryDivision = ""
    let queryParams = ""
    if (idDivisionSelected) {
      queryDivision = `&id_division=${idDivisionSelected}`
    }
    if (measureGeneral.segments.length > 1 && selectedSegment) {
      querySegment = `&id_segment=${selectedSegment}`
    }
    if (queryDivision !== "" || querySegment !== "") {
      queryParams = `${"?home=true"}${queryDivision}${querySegment}`
    }
    let link = `/reports/measure/${idMeasure}/teams/${idDivisionSelected ||
      "all"}/dimensions${queryParams}`
    if (isLeader() && props.measureTotal.measure_id_segment) {
      querySegment = `?home=true&id_segment=${props.measureTotal.measure_id_segment}`
      link = `/reports/measure/${idMeasure}/teams/${idDivisionSelected ||
        "all"}/dimensions${querySegment}`
    }
    return (
      <div
        className="WidgetResultByDimension-container-chart-header-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          width: "100%",
        }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="WidgetResultByDimension-container-chart-header-container-title">
            {intlWidgetResultByDimensionTeam.title}
          </div>
          <div className="WidgetResultByDimension-container-chart-header-container-link">
            <Link to={link}>{intlWidgetResultByDimensionTeam.link}</Link>
          </div>
        </div>
        <Select
          style={{ width: "200px" }}
          allowClear
          placeholder={intlWidgetResultByDimensionTeam.selectLeaderPlaceHolder}
          onChange={changeDivision}
          onClear={initGetData}>
          {teams.map((team, index) => (
            <Option value={team.id_position} key={index}>
              {team.name}
            </Option>
          ))}
        </Select>
      </div>
    )
  }

  const getDataChildren = (data) => {
    if (
      validate.exist(data.childs) &&
      data.childs.length > 0 &&
      data.employees >= data.anonymity_check.current_used
    ) {
      setDimensionParent(data.id)
    }
  }

  const getBackData = (idDimensionParent) => {
    const result = searchItemInTree(
      [...props.dimensionsDrillDown],
      idDimensionParent
    )
    setDimensionParent(result.id_parent)
  }

  const renderChart = () => {
    const { measureGeneral, showDimensionBenchmark } = props
    return (
      <ResultByDimensionChart
        data={dataAux}
        measureGeneral={measureGeneral}
        getDataChildren={getDataChildren}
        getBackData={getBackData}
        dimensionParent={dimensionParent}
        showDimensionBenchmark={showDimensionBenchmark}
        hideImpact
      />
    )
  }

  const renderContainer = () => {
    if (props.isLoadingDimensions) {
      return (
        <div className="WidgetResultByDimension-container">
          <div className="WidgetResultByDimension-container-chart">
            <div className="WidgetResultByDimension-container-chart-header">
              {renderTitle()}
            </div>
            <div className="loadingSpin">
              <Spin size="large" />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="WidgetResultByDimension-container">
        <div className="WidgetResultByDimension-container-chart">
          <div className="WidgetResultByDimension-container-chart-header">
            {renderTitle()}
          </div>
          <div className="WidgetResultByDimension-container-chart-container">
            {renderChart()}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="WidgetResultByDimension"
      style={{
        // width: props.measureGeneral.has_enps ? "76%" : "100%",
        width: "100%",
      }}>
      {renderContainer()}
    </div>
  )

  /* return (
    <ResultDrillDown
      isTooltip
      excludeSub={false}
      style={{
        width: props.measureGeneral.has_enps ? "80%" : "100%",
        marginBottom: "0",
      }}
      textLeyend="Estilo de liderazgo"
      isLoading={props.isLoadingDimensions}
      metric={null}
      data={props.dimensionsDrillDown}
      filters={{
        show: true,
        filters: props.teams.filter((obj, pos, arr) => {
          return (
            arr.map((mapObj) => mapObj.id_position).indexOf(obj.id_position) ===
            pos
          )
        }),
        id: "id_position",
        name: "name",
        placeHolder: "Seleccionar equipo",
        onChange: (e) => {
          changeDivision(e)
        },
      }}
      subLink={{
        title: "Ir a análisis detallado >",
        link: `/reports/measure/${props.idMeasure}/teams/all/dimensions${querySegment}`,
      }}
      title="Resultado por dimensión"
    />
  ) */
}

WidgetResultByDimensionTeam.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  isLoadingDimensions: PropTypes.bool,
  dimensionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  teams: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getDimensions: PropTypes.func,
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoadingDimensions: makeSelectIsLoadingDimensions(),
  dimensionsDrillDown: makeSelectDimensionsDrillDown(),
  teams: makeSelectTeams(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({
  key: "widgetResultByDimensionTeam",
  reducer,
})
const withSaga = injectSaga({ key: "widgetResultByDimensionTeam", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetResultByDimensionTeam)
